import React from 'react';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import Input from 'src/components/Input';
import CreatableSelect from 'react-select/creatable';
import { selectStyles } from './selectStyles';

const noOptionsMessage = () => 'Please type and hit enter to create a new item';

interface ParkingStorageSectionProps {
  suiteFormData: any;
  isSparkDisabled: boolean;
  checkingSlotType: string | null;
  onCheckExistingParkingStallStorageLockers: (
    newValue: any,
    latestValue: any,
    type: string
  ) => void;
  onSetSuiteFormData: (data: any) => void;
}

const ParkingStorageSection = ({
  suiteFormData,
  isSparkDisabled,
  checkingSlotType,
  onCheckExistingParkingStallStorageLockers,
  onSetSuiteFormData,
}: ParkingStorageSectionProps) => {
  return (
    <Row>
      <Col xs="12" md="6">
        <div className="suite-form-field">
          <div className="reporting__heading suite-form-label">Parking Stalls :</div>
          <CreatableSelect
            placeholder="Enter Parking Stall"
            isClearable
            isMulti
            value={suiteFormData.parkingStalls ? suiteFormData.parkingStalls : []}
            onChange={(newValue: any, actionMeta: any) =>
              onCheckExistingParkingStallStorageLockers(
                newValue,
                actionMeta,
                'parkingStalls'
              )
            }
            isDisabled={isSparkDisabled}
            isLoading={checkingSlotType === 'parkingStalls'}
            styles={selectStyles}
            noOptionsMessage={noOptionsMessage}
          />
        </div>
      </Col>
      <Col xs="12" md="6">
        <div className="suite-form-field">
          <div className="reporting__heading suite-form-label">Storage Lockers :</div>
          <CreatableSelect
            placeholder="Enter Storage Locker"
            isClearable
            isMulti
            value={
              suiteFormData.storageLockers ? suiteFormData.storageLockers : []
            }
            onChange={(newValue: any, actionMeta: any) =>
              onCheckExistingParkingStallStorageLockers(
                newValue,
                actionMeta,
                'storageLockers'
              )
            }
            isDisabled={isSparkDisabled}
            isLoading={checkingSlotType === 'storageLockers'}
            styles={selectStyles}
            noOptionsMessage={noOptionsMessage}
          />
        </div>
      </Col>
      <Col xs="12" md="6">
        <div className="suite-form-field">
          <div className="reporting__heading suite-form-label">Key Fobs Assignment :</div>
          <CreatableSelect
            value={suiteFormData.keyFobs ? suiteFormData.keyFobs : []}
            onChange={(e: any) => onSetSuiteFormData({ keyFobs: e })}
            isClearable
            isMulti
            styles={selectStyles}
            noOptionsMessage={noOptionsMessage}
          />
        </div>
      </Col>
      <Col xs="12" md="6">
        <div className="suite-form-field">
          <Input
            value={suiteFormData.numberOfKeys ? suiteFormData.numberOfKeys : ''}
            onChange={(e: any) =>
              onSetSuiteFormData({ numberOfKeys: e.target.value })
            }
            label="Number of Physical Keys :"
            block
          />
        </div>
      </Col>
    </Row>
  );
};

export default ParkingStorageSection;
